module.exports = __webpack_public_path__ + "static/img/01img.627bb1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/01challengeList/01img.png
// module id = jFnN
// module chunks = 0